<template>
  <section class="section has-text-dark has-background-white">
    <div class="container">
      <h1>NCCN Registration</h1>
      <form @submit.prevent="validateBeforeSubmit('register')" data-vv-scope="register">
        <div class="columns">
          <div class="column is-5">
            <div class="field">
              <label class="label required">{{labels.emailLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="email" v-model="model.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('register.email') }" type="text" readonly>
                <i v-show="errors.has('register.email')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.email')" class="help is-danger">{{errors.first('register.email')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.salutationLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="salutations">
                  <li v-for="item in model.SalutationList" :key="item.Text">
                    <label class="checkbox">
                      <input name="salutation" v-bind:value="item.Text" v-model="model.Salutation" type="radio" v-on:click="checkOthers(item.Text, 'Salutation')">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
              </p>
              <input v-bind:disabled="isDisabled(isOtherSalutationActive)" name="other" v-model="model.OtherSalutation"  type="text" :class="{'input': true}" />
            </div>
            <div class="field">
              <label class="label required">{{labels.firstNameLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="firstname" v-model="model.FirstName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('register.firstname') }" type="text">
                <i v-show="errors.has('register.firstname')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.firstname')" class="help is-danger">{{errors.first('register.firstname')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.lastNameLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="lastname" v-model="model.LastName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('register.lastname') }" type="text">
                <i v-show="errors.has('register.lastname')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.lastname')" class="help is-danger">{{errors.first('register.lastname')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.passwordLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input v-model="model.Password" v-validate="'required'" ref="password" name="password" type="password" :class="{'input': true, 'is-danger': errors.has('register.password') }">
                <i v-show="errors.has('register.password')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.password')" class="help is-danger">{{errors.first('register.password')}}</span>
            </div>
            <div class="field">
              <label class="label required">{{labels.repeatPasswordLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input v-model="model.RepeatPassword" v-validate="'required|confirmed:password'" name="password_confirmation" type="password" data-vv-as="password" :class="{'input': true, 'is-danger': errors.has('register.password_confirmation') }">

                <i v-show="errors.has('register.password_confirmation')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.password_confirmation')" class="help is-danger">{{errors.first('register.password_confirmation')}}</span>
            </div>
            <div class="field">
              <label class="label required">{{labels.scienceEducationCommunityLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="genders">
                  <li v-for="item in model.ScienceEducationCommunityList" :key="item.Text">
                    <label class="radio">
                      <input name="science" v-bind:value="item.Text" v-model="model.ScienceEducationCommunity" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text, 'Science')">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
              </p>
              <input v-bind:required="isRequired(isOtherScienceActive)" v-bind:disabled="isDisabled(isOtherScienceActive)" name="science" v-model="model.OtherScience" type="text" :class="{'input': true, 'is-danger': errors.has('register.science') }" />
              <i v-show="errors.has('register.science')" class="fa fa-warning"></i>
              <span class="help is-danger" v-show="errors.has('register.science')">The role field is not valid.</span>
            </div>
            <div class="field">
              <label class="label required">{{labels.cityLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="city" v-model="model.City" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register.city') || cityInValid }" type="text">
                <i v-show="errors.has('register.city') || cityInValid" class="fa fa-warning"></i>
                <span v-show="errors.has('register.city')" class="help is-danger">{{errors.first('register.city')}}</span>
                <span v-show="cityInValid" class="help is-danger"> The city field may only contain alphabetic or numeric characters.</span>

              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.stateLabel}}</label>
              <p class="control has-icon has-icon-right">
                <div class="select">
                  <select v-model="model.State" :class="{'input': true, 'is-danger': errors.first('register.state') || stateInvalid }">
                    <option v-for="option in model.States" v-validate="'required'" v-bind:value="option.Value">
                      {{ option.Text }}
                    </option>
                  </select>
                </div>
                <i v-show="errors.has('register.state') || stateInvalid" class="fa fa-warning"></i>
                <span v-show="errors.has('register.state') || stateInvalid" class="help is-danger">The state field is required.</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.zipCodeLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="zipCode" v-model="model.ZipCode" v-bind:required="isRequiredPostCode" :class="{'input': true, 'is-danger': isRequiredPostCode|| zipCodeInValid}" type="text" v-uppercase>
                <i v-show="isRequiredPostCode || zipCodeInValid" class="fa fa-warning"></i>
                <span v-show="isRequiredPostCode" class="help is-danger">The zip code field is required</span>
                <span v-show="zipCodeInValid" class="help is-danger">The zip code field is not valid.</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.affiliationLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="affiliation" v-model="model.Affiliation" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register.affiliation') }" type="text">
                <i v-show="errors.has('register.affiliation')" class="fa fa-warning"></i>
                <span v-show="errors.has('register.affiliation')" class="help is-danger">{{errors.first('register.affiliation')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.participationLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="genders">
                  <li v-for="item in model.ApplyParticipationList" :key="item.Text">
                    <label class="radio">
                      <input name="Participation" v-bind:value="item.Value" v-model="model.ParticipationId" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register.participation')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register.participation')">{{errors.first('register.participation')}}</span>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit" id="register-sbm">Submit</button>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'register',
    data() {
      return {
        model: {
        },
        errored: false,
        labels: [],
        isOtherSalutationActive: false,
        isOtherScienceActive: false,
        loading: false
      }
    },
    computed: {
      cityInValid() {
        return !(!this.model.City || /^\s*$/.test(this.model.City))  && /^[A-Za-z0-9\s]+$/.test(this.model.City) == false;
      },
      zipCodeInValid() {
        return !(!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && this.model.State != null && this.model.State != "Outside the United States" ? /^[/\d]{5}?$/.test(this.model.ZipCode) == false : !(!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode))  &&  /^[A-Za-z0-9_\-\s]+$/.test(this.model.ZipCode) == false;
      },
      affiliationInValid() {
        return !(!this.model.Affiliation || /^\s*$/.test(this.model.Affiliation)) && /^[A-Za-z0-9\s]+$/.test(this.model.Affiliation) == false;
      },
      stateInvalid() {
        return !this.model.State && this.errored;
      },
      isRequiredPostCode() {
        return (!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && this.model.State != null && this.model.State != "Outside the United States" ? true : false;
      }
    },
    created() {
      if (localStorage.getItem("registration-activation-link") == this.$route.query.id) {
        window.location.href = "/register/link-activation/";
      }
      this.axios
        .get('/umbraco/surface/RegisterSurface/Register')
        .then(response => {
          if (response.data.redirectURL != undefined) {
            this.loading = false;
            window.location.href = response.data.redirectURL;
          }
          this.model = response.data.model;
          this.model.Email = this.$route.query.e;
          this.model.FirstName = this.$route.query.fn;
          this.model.LastName = this.$route.query.ln;
          this.model.ParticipationId = this.$route.query.p;
          this.labels = response.data.labels;
          this.model.RegistrationId = this.$route.query.id;
          
          if (this.model.OtherSalutation)
            this.isOtherSalutationActive = true;
          if (this.model.OtherScience)
            this.isOtherScienceActive = true;
         
        
        })
        .catch(error => {
          this.errored = true
        })
     
    },
    methods: {
      validateBeforeSubmit(scope) {
        this.errored = true;
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/RegisterSurface/PostRegister',
                this.model
              )
              .then(response => {
                if (response.data.error) {
                  this.loading = false;
                  alert(response.data.error);
                }
                else if (response.data.redirectURL != "") {
                  this.loading = false;
                  localStorage.setItem("registration-activation-link", this.$route.query.id);
                  window.location.href = response.data.redirectURL;
                }

              })
              .catch(function (error) {
                this.errored = true;
              });
            return;
          }
          else {
            $('html, body').animate({
              scrollTop: ($('.is-danger:visible').offset().top - 100)
            }, 500);

            return;
          }
        });
      },
      checkOthers(value, type) {
        switch (type) {
          case "Salutation":
            if (value == "Other:")
              this.isOtherSalutationActive = true;
            else {
              this.isOtherSalutationActive = false;
              this.model.OtherSalutation = "";
            }
            break;
          case "Science":
            if (value == "Other:")
              this.isOtherScienceActive = true;
            else {
              this.isOtherScienceActive = false;
              this.model.OtherScience = "";
            }
              
            break;
        }

      },
      isDisabled(value) {
        return value == true ? null : "disabled";
      },
      isRequired(value) {
        return value ? true : false;
      }
    }
  };

</script>




// WEBPACK FOOTER //
// src/components/Register.vue